<template>
<div class="profiletable__row flex w-full text-bold">
  <div class="profiletable__row__data bg--gray-lightest flex-none w-150">
    GSoD Indices 2021
  </div>
  <div class="profiletable__row__data bg--gray-lightest flex-auto">
    COVID-19 related measures/developments with an impact on Democracy and Human Rights
  </div>
  <div class="profiletable__row__data bg--gray-lightest flex-none w-100 text-center">
    Impact
  </div>
</div>
</template>

<script>
export default {
  'name': 'profile-table-header'
}
</script>



// WEBPACK FOOTER //
// src/components/covid19/ProfiletableHeader.vue